import type { IconSvgObject } from './types';

const ImageCropIcon: IconSvgObject = [
  ["path", { d: "M2 3.5H18.5C19.6046 3.5 20.5 4.39543 20.5 5.5V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 20.5L5.5 20.5C4.39543 20.5 3.5 19.6046 3.5 18.5L3.5 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 20.5L13.801 13.0192C14.5045 12.4212 15.5259 12.3825 16.2726 12.9256L20.5 16", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ImageCropIcon;
